<template>
  <div
    v-if="getTabsByDeviceType.length"
    class="rf-settings-goal-tracking rf-custom-web-card-wrapper"
  >
    <RfButtonTabs :active="tab">
      <RfButtonNew
        v-for="(item, i) in getTabsByDeviceType"
        :key="item.value"
        type="plain"
        class="[&_.rf-button--container]:text-beige-50 px-4 py-2"
        :class="{
          '[&_.rf-button--container]:text-black-2 [&_.rf-button--container]:font-bold!': i === tab,
        }"
        @click="tab = i"
      >
        {{ item.name }}
      </RfButtonNew>
    </RfButtonTabs>
    <v-tabs-window :modelValue="getTabsByDeviceType[tab].value">
      <v-window-item v-for="item in getTabsByDeviceType" :key="item.value" :value="item.value">
        <component
          :is="codeEditor.CodeEditor"
          v-bind="{ ...codeEditor.props, lineNums: false, readOnly: true, wrap: true }"
          :modelValue="getCodeByLanguage(item.value)"
          :languages="codeEditor.languages(item.value)"
        ></component>
      </v-window-item>
    </v-tabs-window>
  </div>
</template>

<script setup>
import RfButtonNew from "@/components/buttons/RfButtonNew.vue";
import RfButtonTabs from "@/components/buttons/RfButtonTabs.vue";
import { useCodeEditor } from "@/utils/composables/useCodeEditor";
import { computed, ref } from "vue";

const props = defineProps({
  customField: { type: Object, required: true },
  app: { type: Object, required: true },
});

const codeEditor = useCodeEditor();
const tab = ref(0);

const getTabsByDeviceType = computed(() => {
  if (
    props.customField &&
    props.customField.data_type &&
    props.customField.data_type === "custom"
  ) {
    return [
      { value: "bash", name: "cURL" },
      { value: "js", name: "Javascript" },
      { value: "js_third_party", name: "External Web Tracker" },
      { value: "html", name: "HTML" },
      { value: "swift", name: "Swift" },
      { value: "kotlin", name: "Kotlin" },
      { value: "brightscript", name: "Brightscript" },
    ];
  }
  return [];
});

const getCodeByLanguage = val => {
  let code;
  switch (val) {
    case "bash":
      code = `curl -H 'rf-app: ${props.app.id}' -H 'user-id: ENDUSER_ID' 'https://conduit.redfast.com/ping/?type=${props.customField.data_type}&custom_field_id=${props.customField.id}`;
      break;
    case "js":
      code = `Redfast.customTrack("${props.customField.id}");`;
      break;
    case "js_third_party":
      code = `// Add rf_uid url to 3rd party redirect landing page
// e.g. https://example.com?campaign_id=456&rf_uid=123
// The following code will save the user id into local storage
(function() {
  // update rf_user_id to your query selector
  const results = window.location.search.split("&").find(item => item.match(/rf_uid=/))
  const userId = results.split("=").slice(-1)[0];
  localStorage.setItem("rf_user_id", userId);
})();

// Add to conversion page
// The following code will take the saved user id and notify Recurly Engage
(function() {
  if (localStorage.getItem("rf_uid")) {
    fetch("https://conduit.redfast.com/ping/?type=${props.customField.data_type}&custom_field_id=${props.customField.id}", {
      headers: {
        "USER-ID": localStorage.getItem("rf_uid"),
        "Rf-App": "${props.app.id}"
      }
    });
    localStorage.removeItem("rf_uid");
  }
})();
`;
      break;
    case "html":
      code = `<img src="https://conduit.redfast.com/ping/?type=${props.customField.data_type}&custom_field_id=${props.customField.id}" />`;
      break;
    case "swift":
      code = `PromotionManager.customTrack("${props.customField.id}")`;
      break;
    case "kotlin":
      code = `PromotionManager.customTrack("${props.customField.id}")`;
      break;
    case "brightscript":
      code = `m.promoMgr.callFunc("customTrack", { custom_field_id: "${props.customField.id}" })`;
      break;
    default:
  }
  return code;
};
</script>
